import React, {Component} from "react";
import Table from "../../../components/Table";
import MovementItem from "./MovementItem";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";
import {fromJS, List} from "immutable";
import {graphql} from "react-apollo";
import gql from "graphql-tag";

class MovementsList extends Component {

  render() {
    let {loading, error, stockMovements} = this.props.data;
    if (loading) return <Loading />
    if (error) return <GraphQLErrors error={error} />
    let tableHeader = List([
      "Warehouse",
      "Action",
      "Qty.",
      "SKU",
      "Reason",
      "Time"
    ])
    return (
      <Table 
        data={fromJS(stockMovements)} 
        renderer={MovementItem} 
        onItemClick={this.handleItemClick.bind(this)}
        tableHeader={tableHeader}
        extraClassName="MovementsList"
        itemKey="movementId"
        mode="table"
        />
    )
  }

  handleItemClick(itemData, e, field = "") {
  }  

}

const STOCK_MOVEMENTS = gql`
  query stockMovements($warehouseId: ID) {
    stockMovements(warehouseId: $warehouseId) {
      movementId
      movementType
      warehouseId
      reason
      sku
      quantity
      occuredAt
    }
  }
`;

const withQuery = graphql(STOCK_MOVEMENTS, {
  options: (props) => ({
    fetchPolicy: "network-only",
    variables: {
      warehouseId: props.warehouseFilter
    }
  })
})

export default withQuery(MovementsList);